import request from "@/utils/request";
// 新闻页
export let indexJson = (params) => {
  return request({
    url: "/portal/index/indexjson",
    method: "get",
    params,
  });
};

// 关于我们
export let About = (params) => {
  return request({
    url: "/portal/index/about",
    method: "get",
    params,
  });
};

// 右侧推荐
export let postPageRight = (params) => {
  return request({
    url: "/portal/index/postPageRight",
    method: "get",
    params,
  });
};

// 首页轮播图
export let banner = () => {
  return request({
    url: "/portal/index/banner",
    method: "GET",
  });
};
// 图书类型
export let bookTypeList = () => {
  return request({
    url: "portal/books/bookTypeList",
    method: "GET",
  });
};
// 图书列表
export let booksList = (params) => {
  return request({
    url: "/portal/index/getPostPage",
    method: "get",
    params,
  });
};
// 图书详情
export let bookDetail = (data) => {
  return request({
    url: "/portal/index/getPostInfo",
    method: "POST",
    params: data,
  });
};
// 期刊列表
export let journalsList = (params) => {
  return request({
    url: "/portal/index/journals",
    method: "get",
    params,
  });
};
//新闻详情
export let newsDetail = (data) => {
  return request({
    url: "portal/list/newsDetail",
    method: "POST",
    params: data,
  });
};

//books生成订单
export let createBooksOrderInfo = (data) => {
  return request({
    url: "portal/page/createBooksOrderInfo",
    method: "POST",
    params: data,
  });
};
//books订单支付状态检查
export let checkBooksOrder = (data) => {
  return request({
    url: "portal/page/checkBooksOrder",
    method: "POST",
    params: data,
  });
};
//会议接口
export let conferenceDataList = (data) => {
  return request({
    url: "portal/Conference/dataList",
    method: "POST",
    params: data,
  });
};
// 会议详情接口
export let conferenceDetailInfo = (data) => {
  return request({
    url: "portal/Conference/detailInfo",
    method: "POST",
    params: data,
  });
};
//查询接口
export let searchList = (data) => {
  return request({
    url: "portal/index/searchList",
    method: "POST",
    params: data,
  });
};

//特刊列表接口
export let publicationList = (params) => {
  return request({
    url: "portal/publication/list/id",
    method: "GET",
    params,
  });
};

//特刊详情
export let publicationInfo = (id) => {
  return request({
    url: `portal/publication/info/id/${id}`,
    method: "GET",
  });
};

//业务范畴
export let pageInfo = (params) => {
  return request({
    url: "portal/index/page",
    method: "GET",
    params,
  });
};

// 电子书
export let ebookDetail = (data) => {
  return request({
    url: "/portal/index/ebook",
    method: "get",
    params: data,
  });
};
